<template>
	<v-avatar @click="$emit('click')" v-if="(hasPicture || canEdit || showLabelIfNoImage) && item && item.PictureId" :width="width" height="auto" min-height="50" class="text-right" :color="hasPicture || loading ? void 0 : 'primary'" :tile="hasPicture ? tile: false">
		<v-hover v-if="hasPicture" v-slot:default="{hover}">
			<v-img
				:src="$buildURL(`/ftgpicture/${encodeURIComponent(item.FtgId)}/${encodeURIComponent(item.PictureId)}`, {apiRoute: true})"
				:lazy-src="$buildURL(`/ftgpicture/${encodeURIComponent(item.FtgId)}/${encodeURIComponent(item.PictureId)}`, {apiRoute: true})"
			>
				<v-row dense class="fill-height ma-0"
					slot="placeholder"
					align="center"
					justify="center"
				>
					<v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
				</v-row>

				<v-fade-transition hide-on-leave>
					<v-row dense v-if="hover && canEdit" justify="center">
						<v-col cols="12" class="text-center">
							<v-btn outlined icon color="accent" @click="$refs.editDialog.show()"><v-icon>mdi-pencil</v-icon></v-btn>
						</v-col>
					</v-row>
				</v-fade-transition>
			</v-img>
		</v-hover>

		<v-btn v-else-if="canEdit && !loading" icon x-large color="white" @click="$refs.editDialog.show()"><v-icon>mdi-camera-plus</v-icon></v-btn>

		<span v-else-if="!loading" class="white--text" :class="{[spanclass]: true}">{{getNamnInitials(item)}}</span>

		<PictureEditDialog
						ref="editDialog"
						v-if="item"
						:item="item"
						:title="$t('FtgPicture.Title')"
						:save-handler="saveFtgPicture"
						:delete-handler="deleteFtgPicture"
		>
			<template slot="text">
				<p>{{$t('FtgPicture.Description1')}}</p>
				<p>{{$t('FtgPicture.Description2')}}</p>
			</template>
		</PictureEditDialog>
	</v-avatar>
</template>

<script>
import {mapState}        from 'vuex';
import PictureEditDialog from './PictureEditDialog.vue';

export default {
	name:       'CompanyTableAvatar',
	components: {PictureEditDialog},
	props:      {
		item: {
			type:     Object,
			required: true,
		},

		width: {
			type:    String,
			default: 'auto',
		},

		tile: {
			type:    Boolean,
			default: true,
		},

		loading: {
			type:    Boolean,
			default: false,
		},

		spanclass: {
			type:    String,
			default: 'caption',
		},

		canEdit: {
			type:    Boolean,
			default: false,
		},

		showLabelIfNoImage: {
			type:    Boolean,
			default: true,
		},
	},

	methods: {
		onUpdated(Id) {
			this.$emit('updated', Id);

			this.FtgInfo.PictureId = Id;
		},

		getNamnInitials(item) {
			const {Namn, FtgId} = item;

			if(Namn) {
				const first = Namn.slice(0, 1);
				const second = ([...Namn.slice(1)].find((value) => value === value.toUpperCase()) || '');

				return [first.toUpperCase(), second.toUpperCase()].join('');
			}

			return FtgId.slice(0, 2).toUpperCase();
		},

		async saveFtgPicture(data) {
			const {Id} = await this.$http.put(`/ftgpicture`, data);

			this.$emit('updated', Id);
			this.item.PictureId = Id;

			return true;
		},

		async deleteFtgPicture() {
			await this.$http.delete(`/ftgpicture`);

			this.$emit('updated', '00000000-0000-0000-0000-000000000000');
			this.item.PictureId = '00000000-0000-0000-0000-000000000000';

			return true;
		},
	},

	computed: {
		...mapState(['FtgInfo']),

		hasPicture() {
			return this.item && this.item.PictureId !== '00000000-0000-0000-0000-000000000000';
		},
	},
}
</script>

<style scoped>

</style>
